<app-simple-payment-content [vehicleModel]="vehicleModel"
                            (toggleShowCalculator)="onToggleShowCalculator()">
</app-simple-payment-content>

<div *ngIf="showCalculator"
     class="mt-3">
  <app-simple-payment-calculator></app-simple-payment-calculator>
</div>